import DemographicPanel from './demographicPanel.container';

export default DemographicPanel;